"use client";

import React from "react";
import { Facebook, Instagram, Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { FormProvider } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <NavigationMenu className="max-w-full justify-start" viewport={false}>
      <NavigationMenuList className="flex-col items-start space-x-0 gap-3">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm block">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function NewsletterForm() {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };
  return <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
      <Input type="email" placeholder="Enter your email address" className="bg-input/20 border-border/50 focus-visible:ring-primary/50" required />
      <Button type="submit" className="w-full sm:w-auto">
        Join
      </Button>
    </form>;
}
export default function Footer() {
  return <footer id="footer" className="dark bg-background text-foreground py-16 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1593773/img/bathers_auto_detailing_logo.png" alt="Bathers Auto Detailing" className="h-7 w-auto" />
            </Link>
            <p className="text-sm text-muted-foreground mb-6 max-w-xs">
              Professional car care service dedicated to restoring and protecting vehicles with meticulous attention to detail.
            </p>
            <div className="flex gap-2">
              <Button variant="ghost" size="icon" asChild className="text-muted-foreground hover:text-primary">
                <Link to="#" aria-label="Instagram" newTab>
                  <Instagram className="size-5" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" asChild className="text-muted-foreground hover:text-primary">
                <Link to="#" aria-label="Facebook" newTab>
                  <Facebook className="size-5" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div>
            <h3 className="font-serif font-semibold text-lg mb-6 tracking-wide">Quick Links</h3>
            <MenuProvider menu_id="47">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-serif font-semibold text-lg mb-6 tracking-wide">Contact</h3>
            <div className="flex flex-col gap-4">
              <Link to="tel:224-202-7700" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors text-sm group">
                <div className="bg-muted/50 p-2 rounded-md group-hover:bg-primary/10 transition-colors">
                  <Phone className="size-4 text-foreground group-hover:text-primary transition-colors" />
                </div>
                224-202-7700
              </Link>
              <Link to="mailto:jae@bathersautodetailing.com" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors text-sm group">
                <div className="bg-muted/50 p-2 rounded-md group-hover:bg-primary/10 transition-colors">
                  <Mail className="size-4 text-foreground group-hover:text-primary transition-colors" />
                </div>
                jae@bathersautodetailing.com
              </Link>
            </div>
          </div>

          {}
          
        </div>

        {}
        <Separator className="bg-border/40 mb-8" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Bathers Auto Detailing. All rights reserved.</p>
          <p className="font-medium tracking-wide text-foreground/80">Meticulously Designed</p>
        </div>
      </div>
    </footer>;
}